import { IStore } from '../../../app/store'
import GetCurrentLocationCase from "../../../maps/usecases/get-current-location/get-current-location.case";
import MapRepository from "../gateways/map.repository";
import LoadCourtsUseCase from "../../usecases/load-courts/load-courts.case";
import CourtsApiGateway from "../gateways/courts-api.gateway";
import SetMapCenterCase from "../../usecases/set-map-center/set-map-center.case";
import SelectCourtCase from "../../usecases/select-court/select-court.case";
import CourtEntity from "../../../courts/entities/court.entity";

export default class MapController {
  private readonly store: IStore
  private readonly getCurrentLocationCase: GetCurrentLocationCase
  private readonly loadCourtsCase: LoadCourtsUseCase
  private readonly setMapCenterCase: SetMapCenterCase
  private readonly selectCourtCase: SelectCourtCase

  constructor (store: IStore) {
    this.store = store
    const mapRepo = new MapRepository(store)
    const courtApi = new CourtsApiGateway(store)

    this.getCurrentLocationCase = new GetCurrentLocationCase(mapRepo)
    this.loadCourtsCase = new LoadCourtsUseCase(courtApi, mapRepo)
    this.setMapCenterCase = new SetMapCenterCase(mapRepo)
    this.selectCourtCase = new SelectCourtCase(mapRepo, courtApi)
  }

  setDefaultLocation (lat?: any, lng?: any): void {
    try {
      if (lat !== undefined && lng !== undefined) {
        this.setMapCenterCase.execute(parseFloat(lat), parseFloat(lng))
      }
    } catch (e) {
      console.log(e)
    }
  }

  async getLocation (): Promise<void> {
    // this.getCurrentLocationCase.execute()
    this.loadCourtsCase.execute().then(() => {
      console.log('COURTS LOADED')
    })
  }

  changeLocation (lat: number, lng: number): void {
    this.setMapCenterCase.execute(lat, lng)
    this.loadCourtsCase.execute()
  }

  selectCourt (court: CourtEntity): void {
    this.selectCourtCase.execute(court)
  }

  hideCourtModal (): void {
    this.selectCourtCase.execute(null)
  }
}
